import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Col, Divider, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/TimeKeeperSystemType/TimeKeeperSystemTypeModel';
import TimeKeeperSystemTypeService from '../../../services/timeKeeperSystemType/TimeKeeperSystemTypeService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const TimeKeeperEmployerForm: FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const timeKeeperSystemType = useSelector((state: RootState) => state.models.timeKeeperSystem);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.id) ?? '',
    name: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.name) ?? '',
    location: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.location) ?? '',
    ip: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.ip) ?? '',
    port: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.port) ?? '',
    user: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.user) ?? '',
    password: useSelector((state: RootState) => state?.models?.timeKeeperSystem?.password) ?? '',
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const onSaveTimeKeeperSystemType = async () => {
    saveTimeKeeperSystemType(timeKeeperSystemType);
  };

  const { mutate: saveTimeKeeperSystemType, isPending: _isSavingSystem } = useMutation({
    mutationFn: (formData: any) => TimeKeeperSystemTypeService.upsert(timeKeeperSystemType.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !timeKeeperSystemType.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  useEffect(() => {
    form.setFieldsValue(timeKeeperSystemType);
  }, [timeKeeperSystemType]);

  return (
    <Form
      form={form}
      name='timeKeeperSystemTypeForm'
      onValuesChange={handleFieldChange}
      initialValues={initialValues}
      onFinish={onSaveTimeKeeperSystemType}
      layout='vertical'
    >
      <Divider />
      <Row gutter={[16, 16]} className='row'>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Locatia' name='location' rules={[{ required: true, message: 'Introdu locatia!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Ip' name='ip' rules={[{ required: true, message: 'Introdu ip!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Port' name='port' rules={[{ required: true, message: 'Introdu port!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Utilizator' name='user' rules={[{ required: true, message: 'Introdu user!' }]}>
            <Input />
          </Form.Item>
        </Col>
        {!timeKeeperSystemType.id && (
          <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
            <Form.Item label='Parola' name='password' rules={[{ required: true, message: 'Introdu parola!' }]}>
              <Input />
            </Form.Item>
          </Col>
        )}
      </Row>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default TimeKeeperEmployerForm;
